<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="serviceAdd" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="主题名称" prop="ServiceSubject.subjectName">
            <el-input class="input-item" v-model="formData.ServiceSubject.subjectName"
                      :clearable="true" placeholder="主题名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务类型" prop="ServiceSubject.serviceType">
            <el-select class="input-item" v-model="formData.ServiceSubject.serviceType" :clearable="true" filterable
                       placeholder="服务类型" :loading="serviceAdd.serviceType.impl.loading"
                       @visible-change="serviceAdd.serviceType.impl.onVisibleChange"
                       @change="onServiceTypeValueChange">
              <el-option v-for="item in serviceAdd.serviceType.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
<!--        <div>{{JSON.stringify(userInfo)}}</div>-->
        <el-col :span="12" v-if="!userInfo.specialId">
          <el-form-item label="专家" prop="ServiceSubject.specialistName">
            <el-input class="input-item"  v-model="formData.ServiceSubject.specialistName"
                      :key="specialistNameKey" @clear="clearSpecialist()"
                      :clearable="true" placeholder="专家" @focus="onSelectWarehouse()">
              <i class="el-icon-edit el-input__icon" slot="suffix" @click="onSelectWarehouse()"></i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="行业领域" prop="ServiceSubject.industryId">
            <el-cascader class="input-item" v-model="serviceAdd.industryId.value" :options="serviceAdd.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="行业领域"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="serviceAdd.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" prop="ServiceSubject.keyWords">
            <el-input class="input-item" v-model="formData.ServiceSubject.keyWords"
                      :clearable="true" placeholder="关键词,用逗号隔开"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务简介" prop="ServiceSubject.serviceDesc">
            <el-input class="input-item" v-model="formData.ServiceSubject.serviceDesc"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 1}"
                      :clearable="true" placeholder="服务简介"
            />
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--            <el-form-item label="附件" prop="ServiceSubject.attachedFiles">-->
<!--              <el-upload-->
<!--                class="upload-image" name="uploadFile" :headers="getUploadHeaders"-->
<!--                :action="getUploadActionUrl('/admin/app/serviceSubject/upload')"-->
<!--                :data="{fieldName: 'attachedFiles', asImage: true}"-->
<!--                :on-success="onAttachedFilesUploadSuccess"-->
<!--                :on-remove="onAttachedFilesRemoveFile"-->
<!--                :before-upload="pictureFile"-->
<!--                :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--                list-type="picture" :file-list="serviceAdd.attachedFiles.impl.fileList" :limit="serviceAdd.attachedFiles.impl.maxCount"-->
<!--                :show-file-list="true"                        :on-preview="handlePreview">-->
<!--                <el-button size="small" type="primary">点击上传</el-button>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" @click="onAddClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { ServiceSubjectController, DictionaryController } from '@/api';
import specialistSelect from '@/components/specialistSelect';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'serviceAdd',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      userInfo: {},
      imgViewerVisible: false,
      imgList: [],
      specialistNameKey: 0,
      formData: {
        ServiceSubject: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          serviceType: undefined,
          specialistId: undefined,
          industryId: undefined,
          keyWords: undefined,
          serviceDesc: undefined,
          attachedFiles: undefined,
          specialistName: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'ServiceSubject.serviceDesc': [
          {required: true, message: '请输入服务简介', trigger: 'blur'}
        ],
        'ServiceSubject.industryId': [
          {required: true, message: '请输入行业领域', trigger: 'blur'}
        ],
        'ServiceSubject.serviceType': [
          {required: true, message: '请输入服务类型', trigger: 'blur'}
        ],
        'ServiceSubject.subjectName': [
          {required: true, message: '请输入主题名称', trigger: 'blur'}
        ],
        'ServiceSubject.specialistName': [
          {required: true, message: '请输入专家'}
        ],
        'ServiceSubject.keyWords': [
          {required: true, message: '请输入关键字', trigger: 'blur'}
        ]
      },
      serviceAdd: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceType: {
          impl: new DropdownWidget(this.loadServiceTypeDropdownList)
        },
        specialistId: {
          impl: new DropdownWidget(this.loadSpecialistIdDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        attachedFiles: {
          impl: new UploadWidget(5)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
       * 服务类型下拉数据获取函数
       */
    loadServiceTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 服务类型选中值改变
       */
    onServiceTypeValueChange (value) {
    },
    // 客户选择
    onSelectWarehouse () {
      this.specialistNameKey += 1
      this.$dialog.show('选择专家', specialistSelect, {
        area: ['1000px', '600px']
      }, {}).then(res => {
        // alert(JSON.stringify(res))
        this.formData.ServiceSubject.specialistId = res.id
        this.formData.ServiceSubject.specialistName = res.specialistName
        this.$forceUpdate()
      }).catch(e => {
      });
    },
    clearSpecialist () {
      this.formData.ServiceSubject.specialistId = ''
      this.formData.ServiceSubject.specialistName = ''
      this.$forceUpdate()
    },
    /**
       * 专家下拉数据获取函数
       */
    loadSpecialistIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = { auditStatus: '1' };
        DictionaryController.dictSpecialist(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专家选中值改变
       */
    onSpecialistIdValueChange (value) {
    },
    /**
       * 行业领域下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 行业领域选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.ServiceSubject.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 更新新增服务
       */
    refreshServiceAdd (reloadData = false) {
      if (!this.serviceAdd.isInit) {
        // 初始化下拉数据
      }
      this.serviceAdd.isInit = true;
    },
    /**
       * 保存
       */
    onAddClick () {
      this.$refs.serviceAdd.validate((valid) => {
        if (!valid) return;
        this.formData.ServiceSubject.keyWords = this.formData.ServiceSubject.keyWords.replaceAll('，', ',')
        let params = {
          serviceSubjectDto: {
            subjectName: this.formData.ServiceSubject.subjectName,
            serviceType: this.formData.ServiceSubject.serviceType,
            specialistId: this.userInfo.specialId ? this.userInfo.specialId : this.formData.ServiceSubject.specialistId,
            industryId: this.formData.ServiceSubject.industryId,
            serviceDesc: this.formData.ServiceSubject.serviceDesc,
            keyWords: this.formData.ServiceSubject.keyWords,
            attachedFiles: this.formData.ServiceSubject.attachedFiles
          }
        };

        ServiceSubjectController.add(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshServiceAdd(true);
    },
    initFormData () {
    },
    /**
       * 附件上传成功
       */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.serviceAdd.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.ServiceSubject.attachedFiles = this.fileListToJson(this.serviceAdd.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除附件
       */
    onAttachedFilesRemoveFile (file, fileList) {
      this.serviceAdd.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.ServiceSubject.attachedFiles = this.fileListToJson(this.serviceAdd.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
       * 重置表单数据
       */
    resetFormData () {
      this.formData = {
        ServiceSubject: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          serviceType: undefined,
          specialistId: undefined,
          industryId: undefined,
          keyWords: undefined,
          serviceDesc: undefined,
          attachedFiles: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshServiceAdd();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
  },
  watch: {
  }
}
</script>
